module.exports = __webpack_public_path__ + "static/media/gal8.4d59d737.jpg";